import { atom } from "recoil";

import { EntityDto } from "../../../dto";

export const entitiesAtom = atom<EntityDto[] | undefined>({
  key: "entitiesAtom",
  default: undefined,
});
